module.exports = __webpack_public_path__ + "static/media/TN.c8d9b8a1.svg";